// Decodifica el JWT y arma el menú de navegación (compartido por Navbar y Breadcrumb)

const decodeJWT = (token) => {
    try {
        const base64Url = token.split('.')[1];
        const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        const jsonPayload = decodeURIComponent(
            atob(base64)
                .split('')
                .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
                .join('')
        );
        return JSON.parse(jsonPayload);
    } catch (error) {
        console.error('Error decodificando el JWT:', error);
        return null;
    }
};

const processMenu = (items) => {
    return items
        .filter(item => {
            if (item.path === '/solicitud-reemplazo' || item.path === '/ingreso-reemplazos') return false;
            return true;
        })
        .map(item => {
            let newItem = { ...item };

            if (newItem.path === '/new-solicitud-reemplazo') newItem.name = 'Crear';
            if (newItem.path === '/new-ingreso-reemplazos') newItem.name = 'Resolver';

            if (newItem.name === 'Administracion' || newItem.name === 'Administración') {
                if (!newItem.children) newItem.children = [];
                if (!newItem.children.find(c => c.path === '/configuracion-honorarios')) {
                    newItem.children.push({
                        id: 'config-resumen-manual',
                        name: 'Config. Resumen',
                        path: '/configuracion-honorarios',
                        children: []
                    });
                }
                if (!newItem.children.find(c => c.path === '/comunas/distancia')) {
                    newItem.children.push({
                        id: 'comunas-distancia-manual',
                        name: 'Comunas',
                        path: '/comunas/distancia',
                        children: []
                    });
                }
                if (!newItem.children.find(c => c.path === '/creacion-manual-turnos')) {
                    newItem.children.push({
                        id: 'creacion-manual-turnos-manual',
                        name: 'Creacion Manual Turnos',
                        path: '/creacion-manual-turnos',
                        children: []
                    });
                }
            }

            if (newItem.children && newItem.children.some(c => c.path === '/bitacora-coordinacion')) {
                if (!newItem.children.find(c => c.path === '/visitas-paciente-coordinacion')) {
                    newItem.children.push({
                        id: 'visitas-paciente-coordinacion-manual',
                        name: 'Visitas Paciente',
                        path: '/visitas-paciente-coordinacion',
                        children: []
                    });
                }
                if (!newItem.children.find(c => c.path === '/resumen-turnos-coordinacion')) {
                    newItem.children.push({
                        id: 'resumen-turnos-coordinacion-manual',
                        name: 'Resumen de Turnos',
                        path: '/resumen-turnos-coordinacion',
                        children: []
                    });
                }
            }

            if (newItem.name === 'Cobranza') {
                if (!newItem.children) newItem.children = [];
                if (!newItem.children.find(c => c.path === '/reajuste-valores-familia')) {
                    newItem.children.push({
                        id: 'reajuste-valores-familia-manual',
                        name: 'Reajuste Valores Familia',
                        path: '/reajuste-valores-familia',
                        children: []
                    });
                }
                if (!newItem.children.find(c => c.path === '/uso-calendario-2')) {
                    newItem.children.push({
                        id: 'uso-calendario-2-manual',
                        name: 'Uso Calendario 2',
                        path: '/uso-calendario-2',
                        children: []
                    });
                }
            }

            if (newItem.children && newItem.children.length > 0) {
                newItem.children = processMenu(newItem.children);
            }

            return newItem;
        });
};

export const getProcessedMenu = () => {
    const authToken = localStorage.getItem('authToken');
    const decodedToken = authToken ? decodeJWT(authToken) : null;
    const menu = decodedToken?.menu || [];
    return processMenu(menu);
};
